import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/features/page.tsx");
